import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import UnitePaidAndOwnedChannelsImage from './UnitePaidAndOwnedChannelsImage'

const copy = {
  heading: `Unite paid and owned channels`,
  description: `Build audiences that live across every channel in your marketing strategy, and every tool in your stack.`,
}

const UnitePaidAndOwnedChannels = () => (
  <SectionBase variant="centered">
    <SectionCopy>
      <CopyTextBase centered={true}>
        <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
        <CopyText.Description tag="p">{copy.description}</CopyText.Description>
      </CopyTextBase>
    </SectionCopy>
    <Section.Contents>
      <UnitePaidAndOwnedChannelsImage />
    </Section.Contents>
  </SectionBase>
)

const SectionCopy = styled(Section.Copy)`
  max-width: 684px;
`

export default UnitePaidAndOwnedChannels
